// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JiZm","importantInfo":"styles_importantInfo__6U73i"};